"use client";
import React from "react";

export default function PriceRangeSlider({ min, max, value, onChange, minGap = 1000, textColor = '#111', subTextColor = '#444' }) {
  const [minVal, maxVal] = value;
  const minPercent = ((minVal - min) / (max - min)) * 100;
  const maxPercent = ((maxVal - min) / (max - min)) * 100;

  const handleMin = (e) => {
    const val = Math.min(Number(e.target.value), maxVal - minGap);
    onChange([val, maxVal]);
  };
  const handleMax = (e) => {
    const val = Math.max(Number(e.target.value), minVal + minGap);
    onChange([minVal, val]);
  };

  return (
    <div className="w-full">
      <div className="relative slider-container h-8 flex items-center">
        <div className="absolute w-full h-2 bg-gray-200 rounded-md z-0 top-1/2 -translate-y-1/2" />
        <div
          className="absolute h-2 bg-gradient-to-r from-blue-900 to-blue-400 rounded-md z-1 top-1/2 -translate-y-1/2"
          style={{ left: `${minPercent}%`, right: `${100 - maxPercent}%` }}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={minVal}
          onChange={handleMin}
          className="pointer-events-auto z-10"
          style={{ zIndex: minVal > max - 1000 ? 5 : 3 }}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={maxVal}
          onChange={handleMax}
          className="pointer-events-auto z-10"
        />
      </div>
      <div className="flex justify-between mt-2 text-xs" style={{ color: subTextColor }}>
        <span style={{ color: textColor }}>Mín: ${minVal}</span>
        <span style={{ color: textColor }}>Máx: ${maxVal}</span>
      </div>
      <style jsx>{`
        .slider-container input[type='range'] {
          -webkit-appearance: none;
          appearance: none;
          width: 100%;
          position: absolute;
          background: transparent;
          pointer-events: none;
          height: 18px;
        }
        .slider-container input[type='range']::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          background: white;
          border: 3px solid #23a9f7;
          border-radius: 50%;
          cursor: pointer;
          pointer-events: auto;
          position: relative;
          z-index: 3;
          box-shadow: 0 1px 4px rgba(0,0,0,0.08);
        }
        .slider-container input[type='range']::-moz-range-thumb {
          width: 18px;
          height: 18px;
          background: white;
          border: 3px solid #23a9f7;
          border-radius: 50%;
          cursor: pointer;
          pointer-events: auto;
          z-index: 3;
        }
        .slider-container input[type='range']:focus {
          outline: none;
        }
        .slider-container input[type='range']::-webkit-slider-runnable-track {
          height: 2px;
        }
        .slider-container input[type='range']::-ms-fill-lower {
          background: transparent;
        }
        .slider-container input[type='range']::-ms-fill-upper {
          background: transparent;
        }
      `}</style>
    </div>
  );
} 